import { render, staticRenderFns } from "./UploadTerms.vue?vue&type=template&id=6637d8ad&"
import script from "./UploadTerms.vue?vue&type=script&lang=js&"
export * from "./UploadTerms.vue?vue&type=script&lang=js&"
import style0 from "./UploadTerms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports